import React, { Component } from "react";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setLoader } from "../../../actions/action-creators";
import moment from "moment";
import SelectList from "../../global/form/select";
import { TablePagination } from "@material-ui/core";
import CONSTANTS from "../../../constants";
import { accessExotelCallRecording, groupArrayOnKey } from "../../../actions";
import OutboundCallingStatus from "../../global/outbound-calling-status";
import ConfirmAction from "../../global/confirm-action";

const fmtDT = (v) => moment(v).utcOffset("+05:30").format("Do MMM'YY, hh:mm A");

const CALL_STATUS_MAP = {
    "completed":  { label: "Completed",  bg: "#e6f7ee", color: "#1a7a42" },
    "failed":     { label: "Failed",     bg: "#fff0f0", color: "#c0392b" },
    "busy":       { label: "Busy",       bg: "#fff7e6", color: "#d46b08" },
    "no-answer":  { label: "No Answer",  bg: "#f0f0f0", color: "#666"    },
    "in-progress":{ label: "In Progress",bg: "#e6f0ff", color: "#1a5ba8" },
};

const callStatusBadge = (status) => {
    const key = (status || "").toLowerCase();
    const cfg = CALL_STATUS_MAP[key] || { label: status || "—", bg: "#f0f0f0", color: "#666" };
    return (
        <span style={{ background: cfg.bg, color: cfg.color, borderRadius: 999, padding: "3px 10px", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>
            {cfg.label}
        </span>
    );
};

class UserCallDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            callData: [],
            selectedJob: "",
            jobList: [],
            currentPage: 0,
            callDetails: null,
            selectedStatus: "",
        };
    }

    componentDidMount() {
        this.getJob();
        this.fetchCallData();
    }

    getJob = async () => {
        store.dispatch(setLoader(true));
        try {
            let apiData = await ApiEndpoints.Jobs.fetch();
            let jobList = apiData.data.data.sort((a, b) =>
                a.Employer.employer_name > b.Employer.employer_name ? 1 : -1
            );
            this.setState({ jobList });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    fetchCallData = async (selectedJob) => {
        store.dispatch(setLoader(true));
        try {
            let body = { user_id: this.props.user_id };
            if (selectedJob) {
                body.entity_type = ["JOB", "JOB_HELP"];
                body.entity_id = selectedJob;
            }
            let resp = await ApiEndpoints.Calling.fetchDetailsByUser(body);
            let callData = resp.data.data.sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
            this.setState({ callData, selectedJob: selectedJob || "", currentPage: 0 });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    makePhoneCall = async (user) => {
        store.dispatch(setLoader(true));
        try {
            if (this.state.callDetails) {
                store.dispatch(setError({ show: true, message: "You are already on another call." }));
                store.dispatch(setLoader(false));
                return;
            }
            let body = { user_id: user.user_id, entity_type: "GENERAL", direction: 2 };
            let resp = await ApiEndpoints.Calling.connectOutboundCall(body);
            this.setState({ callDetails: { calling_id: resp.data.data.Sid, user } });
        } catch (e) {
            store.dispatch(setError({ show: true, message: typeof e.response.data.message === "string" ? e.response.data.message : "Not able to connect call" }));
        }
        store.dispatch(setLoader(false));
    };

    render() {
        let { callData, selectedJob, jobList, selectedStatus, currentPage } = this.state;
        let { userInfo } = this.props;
        let jobListById = groupArrayOnKey(jobList, "job_id", true);
        let user = store.getState().user;
        let statusOptions = [...new Set(callData.map(c => c.status).filter(Boolean))];
        let filtered = callData.filter(c => selectedStatus ? c.status === selectedStatus : true);
        let page = filtered.slice(currentPage * 10, currentPage * 10 + 10);

        return (
            <div>
                {/* ── Toolbar ── */}
                <div style={S.toolbar}>
                    {!CONSTANTS.OUTBOUND_BLOCKED_USERS.includes(user.user_id) && (
                        <button style={S.callBtn}
                            onClick={() => this.setState({
                                isConfirm: () => this.makePhoneCall(userInfo),
                                isConfirmMessage: `Are you sure to connect with ${userInfo.first_name}?`,
                            })}>
                            📞 Make Call
                        </button>
                    )}
                    <div style={S.filterGroup}>
                        <SelectList placeholder="All Status" value={selectedStatus}
                            onClick={(e) => this.setState({ selectedStatus: e.target.value, currentPage: 0 })}>
                            {statusOptions.map((s, i) => <option key={i} value={s}>{s}</option>)}
                        </SelectList>
                        <SelectList placeholder="All Project Calls" value={selectedJob}
                            onChange={(e) => this.fetchCallData(e.target.value)}>
                            {jobList.map(job => (
                                <option key={job.job_id} value={job.job_id}>
                                    {job.Employer.employer_name + "  -  " + job.title}
                                </option>
                            ))}
                        </SelectList>
                    </div>
                </div>

                {/* ── Call Cards ── */}
                {callData.length === 0 ? (
                    <div style={S.empty}>No call data found.</div>
                ) : (
                    <>
                        {page.map((call, i) => (
                            <div key={i} style={S.card}>
                                <div style={S.cardTop}>
                                    <div>
                                        <div style={S.callName}>
                                            {call.userDetail
                                                ? call.userDetail.first_name
                                                : (userInfo && userInfo.first_name) || "—"}
                                        </div>
                                        <div style={S.callMeta}>
                                            {call.direction === 1 ? "Incoming Call" : "Outgoing Call"}
                                            {["JOB", "JOB_HELP"].includes(call.entity_type) && jobListById[call.entity_id]
                                                ? ` • ${jobListById[call.entity_id].Employer.employer_name} - ${jobListById[call.entity_id].title}`
                                                : ""}
                                        </div>
                                        {!!call.comment && (
                                            <div style={S.callComment}>{call.comment}</div>
                                        )}
                                    </div>
                                    <div style={{ textAlign: "right", flexShrink: 0 }}>
                                        {callStatusBadge(call.status)}
                                        <div style={S.callDate}>{fmtDT(call.created_on)}</div>
                                        {!!call.feedback_score && (
                                            <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>★ {call.feedback_score}</div>
                                        )}
                                    </div>
                                </div>
                                {!!call.call_recording_url && (
                                    <div style={S.audioRow}>
                                        <audio
                                            style={{ width: "100%", height: 36 }}
                                            controls
                                            src={accessExotelCallRecording(call.call_recording_url)}
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={filtered.length}
                            rowsPerPage={10}
                            page={currentPage}
                            onPageChange={(_, p) => this.setState({ currentPage: p })}
                        />
                    </>
                )}

                <ConfirmAction
                    message={this.state.isConfirmMessage}
                    isOpen={!!this.state.isConfirm}
                    onClose={() => this.setState({ isConfirm: false })}
                    callback={this.state.isConfirm}
                />
                {!!this.state.callDetails && (
                    <OutboundCallingStatus
                        calledUser={this.state.callDetails.user}
                        calling_id={this.state.callDetails.calling_id}
                        onClose={() => this.setState({ callDetails: null })}
                    />
                )}
            </div>
        );
    }
}

const S = {
    toolbar:     { display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, marginBottom: 16 },
    filterGroup: { display: "flex", gap: 8, flexWrap: "wrap" },
    callBtn:     { background: "#c0392b", color: "#fff", border: "none", borderRadius: 8, padding: "8px 18px", fontWeight: 700, fontSize: 13, cursor: "pointer" },

    card:        { border: "1px solid #e8e8e8", borderRadius: 12, padding: "14px 18px", marginBottom: 12, background: "#fff" },
    cardTop:     { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 },
    callName:    { fontWeight: 700, fontSize: 15, color: "#1a1a1a", marginBottom: 3 },
    callMeta:    { fontSize: 12, color: "#666", marginBottom: 3 },
    callComment: { fontSize: 12, color: "#888", fontStyle: "italic" },
    callDate:    { fontSize: 11, color: "#aaa", marginTop: 5 },
    audioRow:    { marginTop: 12, borderTop: "1px solid #f0f0f0", paddingTop: 10 },

    empty:       { padding: "40px 20px", textAlign: "center", color: "#aaa", fontSize: 14 },
};

export default UserCallDetails;
